const BoardSkeleton = () => {
  // Array of 5 columns matching your status array
  const skeletonColumns = Array(5).fill(0);
  // Number of cards to show in each column
  const skeletonCards = Array(1).fill(0);

  return (
    <div className="bg-gray min-h-screen animate-pulse">
      {/* Kanban columns */}
      <div className="pt-4 flex space-x-4 overflow-x-auto pb-4 px-4">
        {skeletonColumns.map((_, columnIndex) => (
          <div key={columnIndex} className="flex-1 min-w-[250px]">
            {/* Column header */}
            <div className="rounded-t-lg p-2 bg-gray-200 flex justify-between">
              <div className="h-6 w-24 bg-gray-300 rounded" />{' '}
              {/* Column title placeholder */}
              <div className="h-6 w-8 bg-gray-300 rounded-full" />{' '}
              {/* Count placeholder */}
            </div>

            {/* Column content */}
            <div className="bg-gray-100 p-4 rounded-b-lg min-h-[150px]">
              {skeletonCards.map((_, cardIndex) => (
                <div
                  key={cardIndex}
                  className="bg-white rounded-lg p-4 mb-3 shadow-sm"
                >
                  {/* Card content placeholders */}
                  <div className="space-y-2">
                    <div className="h-4 w-3/4 bg-gray-200 rounded" />
                    <div className="h-4 w-1/2 bg-gray-200 rounded" />
                    <div className="flex justify-between items-center mt-3">
                      <div className="h-4 w-1/3 bg-gray-200 rounded" />
                      <div className="h-6 w-6 bg-gray-200 rounded-full" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BoardSkeleton;
